import { render, staticRenderFns } from "./platform_rule_edit.vue?vue&type=template&id=6a5e8134&scoped=true"
import script from "./platform_rule_edit.vue?vue&type=script&lang=js"
export * from "./platform_rule_edit.vue?vue&type=script&lang=js"
import style0 from "./platform_rule_edit.vue?vue&type=style&index=0&id=6a5e8134&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5e8134",
  null
  
)

export default component.exports